// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"99b3836a236d9b1072d6","293":"f1c62c61e49cbc2143f5","461":"c989ced5a178faca9161","518":"8c6003cee32ae6bd30fc","779":"c7eed1421efc63189246"}[chunkId] + ".js";
};